<div class="pdf-page app-aul-024-24" id="aul02424">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> SEEPAGE AND/OR POLLUTION AND/OR CONTAMINATION EXCLUSION </b>
  </p>

  <p class="font-medium">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <br />
  <p class="font-small">
    Notwithstanding any provision to the contrary within the Policy of which
    this Endorsement forms part (or within any other Endorsement which forms
    part of this Policy), this Policy does not insure:
  </p>
  <br />

  <div class="font-small ps-10">
    <ol type="a" class="ps-20 custom-list">
      <li>any loss, damage, cost or expense, or</li>
      <li>any increase in insured loss, damage, cost or expense, or</li>
      <li>
        any loss, damage, cost, expense, fine or penalty, which is incurred,
        sustained or imposed by order, direction, instruction or request of, or
        by any agreement with, any court, government agency or any public, civil
        or military authority, or threat thereof, (and whether or not as a
        result of public or private litigation),
      </li>
    </ol>
    which arises from any kind of seepage or any kind of pollution and/or
    contamination, or threat thereof, whether or not caused by or resulting from
    a peril insured, or from steps or measures taken in connection with the
    avoidance, prevention, abatement, mitigation, remediation, clean-up or
    removal of such seepage or pollution and/or contamination or threat thereof.
  </div>
  <br />
  <p class="font-small">
    The term any kind of seepage or any kind of pollution and/or contamination
    as used in this Endorsement includes (but is not limited to):
  </p>
  <br />

  <div class="font-small ps-10">
    <ol type="a" class="ps-20 custom-list">
      <li>
        seepage of, or pollution and/or contamination by, anything, including
        but not limited to, any material designated as a 'hazardous substance'
        by the United States Environmental Protection Agency or as a 'hazardous
        material' by the United States Department of Transportation, or defined
        as a 'toxic substance' by the Canadian Environmental Protection Act for
        the purposes of Part II of that Act, or any substance designated or
        defined as toxic, dangerous, hazardous or deleterious to persons or the
        environment under any other Federal, State, Provincial, Municipal or
        other law, ordinance or regulation; and
      </li>
      <li>
        the presence, existence, or release of anything which endangers or
        threatens to endanger the health, safety or welfare of persons or the
        environment.
      </li>
    </ol>
  </div>
</div>
